import React, { createContext, useState, useContext, useEffect } from 'react';
import {login as apiLogin, setLogoutHandler} from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('accessToken'));

    useEffect(() => {
        // Synchronisier mit localstorage
        if (token) {
            localStorage.setItem('accessToken', token);
        } else {
            localStorage.removeItem('accessToken');
        }
    }, [token]);

    const login = async (credentials) => {
        try {
            const response = await apiLogin(credentials);
            setToken(response.data.access_token);
        } catch (error) {
            console.error("Login fehlgeschlagen:", error);
            throw error;
        }
    };

    const logout = () => {
        setToken(null);
        window.location = '/login';
    };

    useEffect(() => {
        setLogoutHandler(logout);
    }, []);

    const isAuthenticated = !!token;

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook
export const useAuth = () => useContext(AuthContext);